// src/pages/PrivacyPolicy.js
import React from 'react';

const PrivacyPolicy = () => {
  return (
    <section className="container mx-auto px-4 py-20">
      <h1 className="text-3xl font-bold text-[#12332A] mb-6">Privacy Policy</h1>
      <div className="text-gray-700">
        <p className="mb-6">Last updated: January 2025</p>

        <p className="mb-6">
          At PerspectiveHQ, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and disclose your personal information.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">1. Information We Collect</h2>
        <p className="mb-4">
          We collect the following types of information:
        </p>
        <ul className="list-disc pl-6 mb-6">
          <li className="mb-2">Personal Identification Information: Name, email address, phone number, etc.</li>
          <li className="mb-2">Usage Data: Information about how you use our website and interact with our services.</li>
          <li className="mb-2">Cookies: We use cookies to improve your browsing experience.</li>
        </ul>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">2. How We Use Your Information</h2>
        <p className="mb-4">
          We use your information to:
        </p>
        <ul className="list-disc pl-6 mb-6">
          <li className="mb-2">Provide and improve our services.</li>
          <li className="mb-2">Communicate with you regarding our services.</li>
          <li className="mb-2">Personalize your experience.</li>
        </ul>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">3. How We Protect Your Information</h2>
        <p className="mb-4">
          We implement security measures to protect your personal information, including encryption and secure servers. However, no method of transmission over the internet is 100% secure.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">4. Sharing Your Information</h2>
        <p className="mb-4">
          We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted partners who assist us in providing our services.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">5. Your Rights</h2>
        <p className="mb-4">
          You have the right to:
        </p>
        <ul className="list-disc pl-6 mb-6">
          <li className="mb-2">Access, update, or delete your personal information.</li>
          <li className="mb-2">Opt-out of marketing communications.</li>
        </ul>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">6. Changes to This Privacy Policy</h2>
        <p className="mb-4">
          We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">7. Contact Us</h2>
        <p className="mb-4">
          If you have any questions about this Privacy Policy, please contact us at:
        </p>
        <p className="mb-4">Email: info@perspectivehq.co.za</p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
